import { PathLayer, PathLayerProps } from "@deck.gl/layers";
import { Feature, LineString } from "geojson";
import { useSelector } from "react-redux";

import { getModelGridFlowLayerOpen, getModelGridLayerOpen } from "../../state/layerCalculationMenu";
import { getLayers } from "../../state/layerOneDMenu";
import { getGridFlowLines, getGridcells } from "../../state/simulation";
import { NodeProperties } from "../../types/assets";

import { getLayerColors } from "./DeckGlConsts";
import useFlowLinesLeveeIntersecting from "./helpers/useFlowLinesLeveeIntersecting";

const useGridLinesLayer = (): PathLayer[] => {
  const oneDLayersStyle = useSelector(getLayers);

  const gridLayerVisible = useSelector(getModelGridLayerOpen);
  const gridCells = useSelector(getGridcells);
  const gridCellsFeatures = gridCells ? gridCells.features : [];

  const gridFlowLinesLayerVisible = useSelector(getModelGridFlowLayerOpen);
  const gridCellsFlowLines = useSelector(getGridFlowLines);
  const gridCellsFlowLinesFeatures = gridCellsFlowLines ? gridCellsFlowLines.features : [];
  const gridCellsFlowLinesLeveeIntersectingFeatures = useFlowLinesLeveeIntersecting();

  const COLORS = getLayerColors(oneDLayersStyle);

  const defaultProps = {
    id: "default-id",
    data: [],
    pickable: false,
    widthMaxPixels: 15,
    getPath: (d) => d.geometry.coordinates.flat().flat(),
    positionFormat: `XY`,
    _pathType: "open",
    opacity: 1,
    capRounded: true,
    jointRounded: true,
  } as PathLayerProps<Feature<LineString, NodeProperties>>;

  return [
    new PathLayer({
      ...defaultProps,
      id: "grid-lines-layer",
      data: gridCellsFeatures,
      getColor: COLORS.GRID_LINES,
      visible: !!gridLayerVisible,
      getWidth: 0.5,
      widthMinPixels: 1,
    }),
    new PathLayer({
      ...defaultProps,
      id: "grid-flow-lines-layer",
      data: gridCellsFlowLinesFeatures,
      getColor: COLORS.GRID_FLOW_LINES,
      visible: !!gridFlowLinesLayerVisible,
      getWidth: 0.5,
      widthMinPixels: 1,
    }),
    new PathLayer({
      ...defaultProps,
      id: "grid-flow-lines-layer-intersecting",
      data: gridCellsFlowLinesLeveeIntersectingFeatures,
      getColor: COLORS.GRID_FLOW_LINES_INTERSECTING,
      visible: !!gridFlowLinesLayerVisible,
      getWidth: 1,
      widthMinPixels: 2,
    }),
  ];
};

export default useGridLinesLayer;
